import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { tickValues, colourPalette, competencyLegend } from '../_base';
import CustomToolTip from '../_tooltip';
import { useSelector } from 'react-redux';
import { SystemText } from 'e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item, id }) => {
    if (!data || !data[0] || !data[0][0]) return <div>{SystemText('Dashboard/Widget/General/InvalidData')}</div>;
    const valuesX = data[0][0].data;
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [legend1, setLegend1] = React.useState('Rating');

    const competencies = useSelector(state => state.dashboard.competencies);
    const { user } = useSelector(state => state.user);
    const ratingRange = user.companySettings?.display?.ratingRange || 5;

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        setBottomTicks(tickValues(valuesX, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            setLegend1(competencyLegend(parsed.competency1, competencies));
        }
    }, [item.data]);

    const cleanData = data[0].map(d => ({ ...d, id: d.full_Name || d.name || d.id }));

    return (
        <ResponsiveLine
            data={cleanData}
            margin={{ top: 10, right: 130, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 0, max: 5 }}
            curve="monotoneX"
            axisTop={null}
            colors={colourPalette}
            xFormat={x => e4Format(x, e4Formats.monthShort)}
            min={0}
            max={ratingRange}
            axisBottom={{
                tickValues: bottomTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => e4Format(x, e4Formats.monthShort),
                legend: 'Month',
                legendOffset: 40,
                legendPosition: 'middle',
            }}
            axisLeft={{
                tickValues: [0, 1, 2, 3, 4, 5],
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: legend1,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridX={false}
            enableGridY
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 16,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            tooltip={point => (
                <CustomToolTip point={point} legendData={cleanData} yFormat={x => parseFloat(x, 10).toFixed(1)} />
            )}
        />
    );
};

export default Chart;
